// INFO: Every entry excludes `tabindex="-1"` of its own accord. An element that is focusable by nature
// still drops out of the tab sequence when it carries a negative tabindex, and the boundaries this list
// feeds are "the first and last stop a tab can reach", not "the first and last focusable node".
const NOT_TABBABLE = ':not([tabindex="-1"])';
const FOCUSABLE_SELECTOR = [
  `a[href]${NOT_TABBABLE}`,
  `button:not([disabled])${NOT_TABBABLE}`,
  `input:not([disabled])${NOT_TABBABLE}`,
  `select:not([disabled])${NOT_TABBABLE}`,
  `textarea:not([disabled])${NOT_TABBABLE}`,
  '[tabindex]:not([tabindex="-1"])',
].join(',');

/**
 * Whether the browser would really put the cursor at the element if asked.
 */
const isFocusable = (element: HTMLElement) =>
  element.getClientRects().length > 0 && element.closest('[inert]') === null;

/**
 * The focusable elements inside a subtree, in document order, which is the order the browser tabs
 * through them.
 */
export const getFocusableElements = (root: ParentNode): HTMLElement[] =>
  Array.from(root.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR)).filter(isFocusable);
